import React, { FunctionComponent, useContext, useState } from 'react';
import { Asset, GenericFileData } from '@api/v4/assets/assetTypes';
import { GelatoPrintConfig } from '@components/gelato';
import { ActionTypes, AssetDetailsDispatch, FlattenedAttachment } from '@components/asset/modal/tabs/edit/EditTabTypes';
import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';
import { TextButton } from '@components/library/button';
import { InputType } from '@components/library/inputs/Input.props';
import InputContainer from '@components/library/input_container/InputContainer';

interface GelatoProductUidScopedContext {
  state: {
    initialData: {
      asset: Asset | null;
    };
    editState: {
      attachments: FlattenedAttachment[];
      genericFileData: GenericFileData;
    };
  };
  dispatch: AssetDetailsDispatch;
}

const GelatoProductUid: FunctionComponent = () => {
  const { state, dispatch }: GelatoProductUidScopedContext = useContext(assetModalContext);
  const { attachments, genericFileData } = state.editState;
  // eslint-disable-next-line @typescript-eslint/camelcase
  const { gelato_product_uid } = genericFileData;

  // eslint-disable-next-line @typescript-eslint/camelcase
  const [gelatoProductUid, setGelatoProductUid] = useState(gelato_product_uid || '');
  const [showGelatoPrintConfig, setShowGelatoPrintConfig] = useState(false);

  const handleGelatoProductUid = (value: string): void => {
    const payload = {
      genericFileData: {
        ...genericFileData,
        gelato_product_uid: value,
      }
    };
    setGelatoProductUid(value);
    dispatch({ type: ActionTypes.UpdateAsset, payload });
  };

  const isGelatoAttachment = attachments.find((attachment) => attachment.extension === 'pdf' || attachment.extension === "bftemplate");

  return (
    <div className="asset-advanced__feature asset-advanced__feature--gelato">
      <div className="gelato-config">
        <div className="gelato-config__form">
          {isGelatoAttachment && (
            <InputContainer
              attributes={{
                id: "gelatoProductUid",
                name: "gelatoProductUid",
                onChange: (e: InputChangeEvent): void => handleGelatoProductUid(e.target.value),
                type: InputType.Text,
              }}
              input={{ value: gelatoProductUid }}
              labelCopy={bfTranslate("Gelato Product ID")}
            />
          )}
          {
            !isGelatoAttachment && (
              <div className="gelato-config__warning-state">
                <span className="bff-warning" />
                <p className="gelato-config__warning-state-copy">{bfTranslate('Add a PDF attachment to enable Gelato printing for this asset.')}</p>
              </div>
            )
          }
          {isGelatoAttachment && (
            <TextButton
              icon={showGelatoPrintConfig ? "bff-hide" : "bff-show"}
              onClick={(): void => setShowGelatoPrintConfig((prev) => !prev)}
            >
              {showGelatoPrintConfig ? bfTranslate('Hide Gelato Config') : bfTranslate('Show Gelato Config')}
            </TextButton>
          )}
        </div>
      </div>
      {showGelatoPrintConfig && <GelatoPrintConfig handleGelatoProductUid={handleGelatoProductUid} />}
    </div>
  );
};

export default GelatoProductUid;
